import { AppDialog } from "../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../common/components/button/defaultButton/DefaultButton";
import {
  Default_Trial_Days,
  Referral_Monthly_Discount_Months,
  Referral_Monthly_Discount_Percent,
  Referral_Trial_Days,
  Referral_Yearly_Discount_Percent,
} from "./models/referralProgramModel";
import styles from "./ReferralProgramDialog.module.scss";

interface IReferralProgramDialogProps {
  visible: boolean;
  onHide: () => void;
}

/**
 * The referral program for studio owners, opened from the last item of the sidebar:
 * the offer and how it works.
 */
export const ReferralProgramDialog = ({
  visible,
  onHide,
}: IReferralProgramDialogProps) => {
  return (
    <AppDialog
      visible={visible}
      onHide={onHide}
      showHeader={false}
      className={styles.root}
      contentClassName={styles.root_content}
      ariaLabelledBy="referral-program-title"
    >
      <div className={styles.root_hero} aria-hidden="true">
        <span className={styles.root_hero_chevron} />
        <span className={styles.root_hero_chevron} />
        <span className={styles.root_hero_percent}>
          {Referral_Monthly_Discount_Percent}%
        </span>
        <span className={styles.root_hero_caption}>отстъпка</span>
      </div>

      <h2 className={styles.root_title} id="referral-program-title">
        Помогнете ни да развием платформата -{" "}
        <span className={styles.root_title_accent}>спечелете и Вие!</span>
      </h2>
      <p className={styles.root_subtitle}>
        Вие получавате отстъпка, а студиото, което препоръчате - {Referral_Trial_Days} дни
        безплатен тестов период вместо&nbsp;{Default_Trial_Days}.
      </p>

      <div className={styles.root_steps}>
        <span className={styles.root_steps_label}>Как работи?</span>
        <ol className={styles.root_steps_list}>
          <li className={styles.root_steps_item}>
            <span className={styles.root_steps_item_number}>1</span>
            <span>
              <b>Поканете друго студио</b> да се присъедини към Planny. Нека каже, че идва{" "}
              <b>по ваша препоръка</b> - така получава{" "}
              <b>
                {Referral_Trial_Days} дни безплатен тестов период вместо {Default_Trial_Days}
              </b>
              .
            </span>
          </li>
          <li className={styles.root_steps_item}>
            <span className={styles.root_steps_item_number}>2</span>
            <div className={styles.root_steps_item_body}>
              <span>
                Ако студиото остане с нас след тестовия си период,{" "}
                <b>получавате отстъпка</b> според това как плаща то:
              </span>
              <div className={styles.root_plans}>
                <div
                  role="group"
                  aria-labelledby="referral-plan-monthly"
                  className={styles.root_plans_plan}
                >
                  <span id="referral-plan-monthly" className={styles.root_plans_plan_label}>
                    Месечно плащане
                  </span>
                  <span className={styles.root_plans_plan_percent}>
                    {Referral_Monthly_Discount_Percent}%
                  </span>
                  <span className={styles.root_plans_plan_text}>
                    от абонамента за {Referral_Monthly_Discount_Months} месеца
                  </span>
                </div>
                <div
                  role="group"
                  aria-labelledby="referral-plan-yearly"
                  className={styles.root_plans_plan}
                >
                  <span id="referral-plan-yearly" className={styles.root_plans_plan_label}>
                    Годишно плащане
                  </span>
                  <span className={styles.root_plans_plan_percent}>
                    {Referral_Yearly_Discount_Percent}%
                  </span>
                  <span className={styles.root_plans_plan_text}>
                    от общата сума на годишния абонамент, наведнъж
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li className={styles.root_steps_item}>
            <span className={styles.root_steps_item_number}>3</span>
            <span>
              Отстъпката се <b>начислява като кредит</b> в акаунта ви и се{" "}
              <b>приспада автоматично</b> от следващите ви фактури, докато кредитът се
              изчерпи.
            </span>
          </li>
        </ol>
      </div>

      <div className={styles.root_actions}>
        <DefaultButton
          label="Затвори"
          design="outline"
          width="100%"
          onClick={onHide}
        />
      </div>
    </AppDialog>
  );
};
